import { DemoSession } from '../types'
import { Examinee } from '../../types'

const SESSION_KEY = 'tg_demo_session'

export const demoSessionStorage = {
  save(session: DemoSession): void {
    sessionStorage.setItem(SESSION_KEY, JSON.stringify(session))
  },

  load(): DemoSession | null {
    const data = sessionStorage.getItem(SESSION_KEY)
    if (!data) return null
    try {
      return JSON.parse(data) as DemoSession
    } catch {
      return null
    }
  },

  clear(): void {
    sessionStorage.removeItem(SESSION_KEY)
  },

  /** セッションが有効か確認（トークン有効期限考慮）*/
  isValid(session: DemoSession | null): boolean {
    if (!session) return false
    // デモトークンは5分間有効だが、ページ遷移やリロードを考慮して
    // クライアント側では10分間を有効期限とする（余裕を持たせる）
    const SESSION_VALIDITY_MINUTES = 10
    const registeredAt = new Date(session.registeredAt)
    const now = new Date()
    const diffMinutes = (now.getTime() - registeredAt.getTime()) / 1000 / 60
    return diffMinutes < SESSION_VALIDITY_MINUTES
  },

  /** DemoSession から Examinee 形式に変換 */
  toExaminee(session: DemoSession): Examinee {
    return {
      scheduleName: session.scheduleName,
      lastName: 'デモ',
      firstName: 'ユーザー',
      number: 'DEMO',
    }
  },
}
